var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle3A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_hairstyle:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33__5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33_a_3_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9E453E",
    d: "M253.1,172.9c2.5-10.5,9.1-20.7,12.1-31.2c2.9-10.1,0.7-20.9,9.5-32.4c11.5-15,42.9-20.2,66.4-22.8 c-6.4,0.1-12.7,0.2-18.8,0.5c-16.5,0.9-32.5,2-46.3,11.2c-15.9,10.6-17.5,20.6-21.3,37.5c-3.6,15.7-11.1,33.5-10.6,49.7 c0.5,16.1,6.8,40.6,11.7,46.8c0.4,0.5,0.8,1,1.2,1.5C258.4,212.8,248.2,193.8,253.1,172.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M451.6,125.1c-2.9-16.2-5.5-27-22.6-33.5c-16-6.1-36.3-5.8-52.9-5.3c-11.3,0.3-23.2,0.2-34.9,0.3 c-23.6,2.5-54.9,7.7-66.4,22.8c-8.8,11.4-6.6,22.3-9.5,32.4c-3,10.5-9.6,20.7-12.1,31.2c-4.9,20.9,5.3,39.8,3.9,61 c3.6,4.7,5.9,10.8,7.6,16.3c1.8-9.5-4.2-23.4,1.3-44.7c1.8-7.1,7.7-14.3,12.2-20.2c5.7-7.4,5.6-10.8,6.1-20.2 c1.2-20.2,14.5-21,31.7-18.4c16.6,2.6,31.9,6.5,49.7,4.3c16.3-2,32.2-9.6,47.1-7.7c20.8,2.6,16.3,21.8,21,38 c3.9,13.4,12.5,17.6,15.2,40.4c1.6,13.9,2.9,25.3,2.4,42c17.1-38.6,9-60.9,11.4-95C463.9,152.5,454.7,143.2,451.6,125.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle3A);
export default __webpack_public_path__ + "static/media/man_hairstyle_3a.2b06bc49ae6fa8f71555a95eca3f268f.svg";
export { ForwardRef as ReactComponent };